import { Component } from 'react';

import moment from 'moment-timezone';

// Styles
import styles, { Circle, Container, DateText, Inner, Item, List, Text } from './styles';

export default class DriverHistoryList extends Component {
  getHistoryStatus(status, type, options) {
    if (type === 'pickupShipment') {
      if (status === 'SUCCEEDED') {
        return (
          <>
            <div>Driver <strong>{options['DRIVER_NAME']}</strong> successfully picked up shipment {options['DRIVER_LABEL']}{options['REMARK'] ? ' with remark:' : ''}</div>
            {options['REMARK'] && <div><i><small>{options['REMARK']}</small></i></div>}
          </>
        );
      } else if (status === 'FAILED') {
        return (
          <>
            <div>Driver <strong>{options['DRIVER_NAME']}</strong> failed to pick up shipment {options['DRIVER_LABEL']}{options['REMARK'] ? ' with remark:' : ''}</div>
            {options['REMARK'] && <div><i><small>{options['REMARK']}</small></i></div>}
          </>
        );
      }
    } else if (type === 'deliverShipment') {
      if (status === 'SUCCEEDED') {
        return (
          <>
            <div>Driver <strong>{options['DRIVER_NAME']}</strong> successfully delivered shipment {options['DRIVER_LABEL']}{options['REMARK'] ? ' with remark:' : ''}</div>
            {options['REMARK'] && <div><i><small>{options['REMARK']}</small></i></div>}
          </>
        );
      } else if (status === 'FAILED') {
        return (
          <>
            <div>Driver <strong>{options['DRIVER_NAME']}</strong> failed to deliver shipment {options['DRIVER_LABEL']}{options['REMARK'] ? ' with remark:' : ''}</div>
            {options['REMARK'] && <div><i><small>{options['REMARK']}</small></i></div>}
          </>
        );
      } else if (status === 'PENDING') {
        return <div>{options['DRIVER_NAME']} is delivering shipment to {options['CUSTOMER_NAME']}</div>;
      }
    }

    return <span>Invalid</span>;
  }

  render() {
    const { status } = styles;
    let events = this.props.history || [];

    return (
      <Container>
        <Inner>
          <List>
            {events.map((h, i) => {
              const options = {
                REMARK: h.remark,
                DRIVER_NAME: h.driver_name || 'unknown',
                DRIVER_LABEL: h.driver_label || 'unknown',
                CUSTOMER_NAME: h.customer_name || 'unknown',
              };

              return (
                <Item key={`event-${h.actual_departure_ts}-${i}`}>
                  <Circle style={{ backgroundColor: status[h.status] }} />
                  <Text>{this.getHistoryStatus(h.status, h.type, options)}</Text>
                  <DateText>{moment(h.actual_departure_ts).format('dddd M/D/YYYY - hh:mm:ss a')}</DateText>
                </Item>
              );
            })}
          </List>
        </Inner>
      </Container>
    );
  }
}
